import Logo from "../../assets/icons/logo.png";
import "./index.scss"

function SplashScreen() {
  return (
    <div className="splash-bg">
      <img src={Logo} alt="logo" />
    </div>
  );
}

export default SplashScreen;
